import React from "react";
import { motion } from "framer-motion";
import { ArrowLeftCircle } from "lucide-react";
import InputPadraoProduto from "../ui/Cliente/InputCliente"; // 👈 seu input padrão

export default function FormularioProduto({ onVoltar, produtoEdicao }) {
  return (
    <motion.div
      className="bg-white rounded-2xl shadow-sm p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      style={{ fontFamily: '"Comfortaa", cursive' }}
    >
      {/* 🔙 Botão Voltar */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={onVoltar}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-800 transition"
        >
          <ArrowLeftCircle size={22} />
          <span className="font-medium">Voltar para lista</span>
        </button>

        <h2 className="text-2xl font-semibold text-gray-700">
          {produtoEdicao ? "Editar Produto" : "Novo Produto"}
        </h2>
      </div>

      {/* 🧾 Formulário */}
      <form className="flex flex-col gap-6">
        {/* Linha de campos */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
          <div className="col-span-2">
            <label className="block text-gray-600 font-medium mb-1">
              Descrição
            </label>
            <InputPadraoProduto
              type="text"
              placeholder="Descrição do produto"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">NCM</label>
            <InputPadraoProduto
              type="text"
              placeholder="Código NCM"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">CEST</label>
            <InputPadraoProduto
              type="text"
              placeholder="Código CEST"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">CSOSN</label>
            <InputPadraoProduto
              type="text"
              placeholder="Código CSOSN"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">PIS</label>
            <InputPadraoProduto
              type="text"
              placeholder="Alíquota PIS"
            />
          </div>

          <div>
            <label className="block text-gray-600 font-medium mb-1">COFINS</label>
            <InputPadraoProduto
              type="text"
              placeholder="Alíquota COFINS"
            />
          </div>
        </div>

        {/* 🔘 Botão Salvar */}
        <div className="flex justify-end mt-6">
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition font-medium"
          >
            Salvar Produto
          </button>
        </div>
      </form>
    </motion.div>
  );
}
